export default "__VITE_ASSET__CWJp3R8Q__ 288w, __VITE_ASSET__C95ztDRl__ 432w, __VITE_ASSET__CNJ5LdGI__ 576w";